import config from './modules/config'
import log from './modules/log'
import user from './modules/user'
import prize from './modules/prize'

export default {
  config,
  log,
  user,
  prize
}